import { render, staticRenderFns } from "./inventory-transfer.vue?vue&type=template&id=7b2b0a79"
import script from "./inventory-transfer.vue?vue&type=script&lang=js"
export * from "./inventory-transfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports